import type { RuntimeContext } from 'hypertube-nodejs-sdk'

import { Runtime } from '@/core/enums/runtime.enum'

type HypertubeModule = typeof import('hypertube-nodejs-sdk')
type HypertubeConnection = ReturnType<HypertubeModule['RuntimeBridge']['withConfig']>

export const RUNTIME_CONNECTION_ACCESSOR_MAP: Record<Runtime, (connection: HypertubeConnection) => RuntimeContext> = {
  [Runtime.Nodejs]: (connection) => connection.nodejs(),
  [Runtime.Jvm]: (connection) => connection.jvm(),
  [Runtime.Netcore]: (connection) => connection.netcore(),
  [Runtime.Python]: (connection) => connection.python(),
  [Runtime.Ruby]: (connection) => connection.ruby(),
  [Runtime.Php]: (connection) => connection.php(),
} as const
